import styled from 'styled-components'
import { disabled } from 'styles'
import { Flex } from 'components'

export const ToggleSwitch = styled(Flex)`
  ${disabled}
`
